import { useGetPlayableItemsQuery } from '../../../../../generated/apollo-hooks';
import useSelector from '../../../../infrastructure/useSelector';
import { shallowEqual } from 'react-redux';

export const usePlayableItems = ({ environmentId, onError, shouldSkip }: { environmentId?: string; onError?: $TSFixMe, shouldSkip?: boolean } = {}) => {
    const { currentSystem, currentEnvironment, supportedSystemType } = useSelector(
        state => ({
            currentSystem: state.common.currentSystem,
            currentEnvironment: state.common.currentEnvironment,
            supportedSystemType: state.common.supportedSystemType
        }),
        shallowEqual
    );

    const { data, ...rest } = useGetPlayableItemsQuery({
        variables: {
            systemId: currentSystem,
            environmentId: environmentId || currentEnvironment?.id
        },
        skip: !currentSystem || !currentEnvironment || !supportedSystemType || shouldSkip,
        onError: error => {
            onError?.(error);
        }
    });

    return { playableItems: data?.getPlayableItems, ...rest };
};
